export const titleMap: Record<string, string> = {
    'prop-001': 'screens.property.prop_001',
    'prop-002': 'screens.property.prop_002',
    'prop-003': 'screens.property.prop_003',
    'prop-004': 'screens.property.prop_004',
    'prop-005': 'screens.property.prop_004_01',
    'prop-006': 'screens.property.prop_006',
    'prop-007': 'screens.property.prop_007',
    'prop-008': 'screens.property.prop_008',
    'prop-009': 'screens.property.prop_009',
    'prop-011': 'screens.property.prop_011',
    'prop-012': 'screens.property.prop_012',
    'prop-013': 'screens.property.prop_013',
    'prop-014': 'screens.property.prop_014',
    'prop-015': 'screens.property.prop_015',
    'prop-016': 'screens.property.prop_016',
    'prop-017': 'screens.property.prop_017',
    'prop-018': 'screens.property.prop_018',
    'prop-019': 'screens.property.prop_019',
    'prop-020': 'screens.property.prop_020',
    'prop-021': 'screens.property.prop_021',
    'prop-022': 'screens.property.prop_022',
    'prop-022-02': 'screens.property.prop_022_02',
    'prop-023-01': 'screens.property.prop-023-01',
    'prop-023-02': 'screens.property.prop-023-02',
    'prop-024': 'screens.property.prop_024',
    'prop-024-02': 'screens.property.prop_024_02',
    'prop-025': 'screens.property.prop_025',
    'prop-025-02': 'screens.property.prop_025_02',
    'prop-026': 'screens.property.prop_026',
    'prop-027': 'screens.property.prop_027',
    'prop-028': 'screens.property.prop_028',
    'prop-029': 'screens.property.prop_029',
    'prop-030': 'screens.property.prop_030',
    'prop-031': 'screens.property.prop_031',
    'prop-032': 'screens.property.prop_032',
    'prop-033': 'screens.property.prop_033',
    'adm-001': 'screens.admin.adm_001',
    'adm-002': 'screens.admin.adm_002',
    'adm-003': 'screens.admin.adm_003',
    'adm-004': 'screens.admin.adm_004',
    'adm-005': 'screens.admin.adm_005',
    'adm-007': 'screens.admin.adm_007',
    'adm-008': 'screens.admin.adm_008',
    'adm-009': 'screens.admin.adm_009',
    'adm-010': 'screens.admin.adm_010',
    'adm-011': 'screens.admin.adm_011',
    'adm-012': 'screens.admin.adm_012',
    'adm-013': 'screens.admin.adm_013',
    'adm-014': 'screens.admin.adm_014',
    'adm-015': 'screens.admin.adm_015',
    'adm-016': 'screens.admin.adm_016',
    'adm-017': 'screens.admin.adm_017',
    'adm-018': 'screens.admin.adm_018',
    'adm-020': 'screens.admin.adm_020',
    'adm-021': 'screens.admin.adm_021',
    'adm-022': 'screens.admin.adm_022',
    'adm-023': 'screens.admin.adm_023',
    'adm-024': 'screens.admin.adm_024',
    'adm-025': 'screens.admin.adm_025',
    'adm-026': 'screens.admin.adm_026',
    'adm-031': 'screens.admin.adm_031',
    'adm-032': 'screens.admin.adm_032'
  }